import { FormModifier, Headline, IconLogoMark, Link, Text } from '@hudl/uniform-ui-components';
import React from 'react';
import * as styles from './styles.scss';
import g11n from 'hudl-g11n';

const CheckYourEmail = () => {
  return (
    <div className={styles.checkEmailContainer}>
      <Link href="/" type="wrapper" className={styles.hudlLogoContainer}>
        <IconLogoMark size="large" />
      </Link>
      <FormModifier className={styles.loginHelpContainer} formSize="large" density="default">
        <Headline level="3">{g11n.format('login_check_email_header')}</Headline>

        <Text className="uni-margin--half--top">{g11n.format('login_check_email_click_link')}</Text>

        <Text className="uni-margin--half--top">{g11n.format('login_check_email_check_junk')}</Text>
      </FormModifier>
    </div>
  );
};

export default CheckYourEmail;
